import React, { useEffect, useState } from 'react'
import useStore from '../../../StorePeople/Store'
import styles from './styles.module.css'

function Name () {
  const { fullName, setFullName, isQueryLoading } = useStore()
  const { name, lastName } = fullName

  const [inputValue, setInputValue] = useState(`${name} ${lastName}`.trim())

  useEffect(() => {
    setInputValue(`${name} ${lastName}`.trim())
  }, [name, lastName])

  useEffect(() => {
    const timer = setTimeout(() => {
      const [firstName, ...rest] = inputValue.split(' ')
      const newLastName = rest.join(' ')

      // Only update if values have changed to avoid unnecessary re-renders
      if (firstName !== name || newLastName !== lastName) {
        setFullName(firstName, newLastName)
      }
    }, 1000)

    return () => clearTimeout(timer)
  }, [inputValue, name, lastName, setFullName])

  const handleChange = event => {
    setInputValue(event.target.value)
  }

  return (
    <div className={styles.nameContainerPeople}>
      <label className={styles.namePeopleLabel} htmlFor='Name'>
        Name
      </label>
      <input
        className={styles.nameInputPeople}
        disabled={isQueryLoading}
        placeholder='John doe'
        onChange={handleChange}
        value={inputValue}
        type='text'
      />
    </div>
  )
}

export default Name
